import { Box, Flex, Icon, Text } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"
import {
  FaBookmark,
  FaCheck,
  FaCog,
  FaHome,
  FaImages,
  FaPen,
  FaRegNewspaper,
  FaTag,
  FaUsers,
  FaWindows,
} from "react-icons/fa"
import { useColorModeValue } from "../UI/color-mode"
import { userHasPermission } from "../../utils"

interface SidebarItemsProps {
  onClose?: () => void
}


const SidebarItems = ({ onClose }: SidebarItemsProps) => {
  const textColor = useColorModeValue("main", "light")
  const bgActive = useColorModeValue("#E2E8F0", "#181a1cff")

  let items = [
    { icon: FaHome, title: "Dashboard", path: "/", perm:  null, is_allowed: true },
    { icon: FaRegNewspaper, title: "Publikationen", path: "/publications", perm: "publications_read", is_allowed: false },
    { icon: FaPen, title: "Autoren", path: "/authors", perm: "authors_read", is_allowed: false },
    { icon: FaTag, title: "Tags", path: "/tags", perm: "tags_read", is_allowed: false },
    { icon: FaBookmark, title: "Kategorien", path: "/categories", perm: "categories_read", is_allowed: false },
    { icon: FaWindows, title: "Werbung", path: "/ads", perm: "ads_overview_read", is_allowed: false },
    { icon: FaImages, title: "Medien", path: "/media", perm: "media_read", is_allowed: false },
    { icon: FaCheck, title: "Formulare", path: "/forms", perm: "form_contact_read", is_allowed: false },
    { icon: FaUsers, title: "Benutzer", path: "/users", perm: "users_read", is_allowed: false },
    { icon: FaCog, title: "Steuerdaten", path: "/settings", perm: "settings_common_read", is_allowed: false }
  ]

  items = userHasPermission(items)

  return (
    <Box>
      {items.map((item) => (
        item.is_allowed &&
          <Flex w="full" p={3} key={item.title} fontSize={18} asChild>
            <Link
              key={item.title}
              to={item.path}
              activeProps={{
                style: {
                  background: bgActive,
                  borderRadius: "12px",
                },
              }}
              onClick={onClose}
            >
              <Icon as={item.icon} alignSelf="center" color={textColor} />
              <Text ml={2} color={textColor}>{item.title}</Text>
            </Link>
          </Flex>
      ))}
    </Box>
  )
}

export default SidebarItems
